var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.521002 1.1059C0.369914 1.23815 0.285037 1.4175 0.285037 1.60451C0.285037 1.79152 0.369914 1.97087 0.521002 2.10312L4.51035 5.5941L0.521001 9.08508C0.374195 9.21809 0.292962 9.39624 0.294798 9.58115C0.296634 9.76607 0.381393 9.94295 0.530818 10.0737C0.680244 10.2045 0.882381 10.2786 1.09369 10.2802C1.30501 10.2819 1.50858 10.2108 1.66058 10.0823L6.21972 6.09271C6.37081 5.96046 6.45569 5.78111 6.45569 5.5941C6.45569 5.40709 6.37081 5.22774 6.21972 5.09549L1.66058 1.1059C1.50945 0.973687 1.3045 0.899414 1.09079 0.899414C0.87709 0.899414 0.672136 0.973687 0.521002 1.1059Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.84e5efdfae978502c7c6d093c28627b4.svg";
export { ForwardRef as ReactComponent };